import {observable, action, runInAction} from 'mobx'
import {PAGE_SIZE_DEFAULT} from '../constants/appConstant'
import marketingShortLinkAPI from '../apis/marketingShortLinkAPI'
import alertMessage from '../utils/alertMessage'

export default class MarketingShortLinkStore {
  constructor(rootStore) {
    this.rootStore = rootStore
  }

  @observable isFetching = false
  @observable pageSize = PAGE_SIZE_DEFAULT
  @observable pageNo = 1
  @observable currIndex = 0
  @observable itemCount = 0
  @observable pageSizeLog = PAGE_SIZE_DEFAULT
  @observable pageNoLog = 1
  @observable currIndexLog = 0
  @observable inBoundNameList = []

  /*SearchResult start*/
  @observable searchItem = {
    'groupName': '',
    'configName': '',
    'shortLinkType': '',
    'isPowerUser' : false,
    'page': this.pageNo,
    'size': this.pageSize,
  }
  @observable jobList = []

  @action
  async onSearchJobAction(params) {
    this.isFetching = true
    this.jobList = []
    this.pageNo = params.page
    this.pageSize = params.size
    this.itemCount = 0
    try {
      const response = await marketingShortLinkAPI.searchAction(params)
      runInAction(() => {
        this.isFetching = false
        if (response.data.code === 0) {
          this.jobList = response.data.data.data?.records || []
          this.itemCount = response.data.data.data?.total
          this.searchItem = params
        }
      })
      return response
    } catch (err) {
      alertMessage.error('处理异常！'+err.message)
      runInAction(() => {
        this.isFetching = false
      })
    }
  }

  //Status 下拉列表
  @observable statusList = []
  @observable typeList = []
  @action
  async onGetStatus(params) {
    if(params==='shortLinkStatus') {
      this.statusList = []
    } else {
      this.typeList = []
    }
    try {
      const response = await marketingShortLinkAPI.getStatus(params)
      const {code, data, messageEn} = response?.data

      runInAction(() => {
        if (code === 0) {
          if(params==='shortLinkStatus') {
            this.statusList = data
          } else {
            this.typeList = data
          }
        } else {
          alertMessage.error('失败！' + messageEn + '')
        }
      })
      return response?.data
    } catch (err) {
      alertMessage.error('处理异常！'+err.message)
      runInAction(() => {
      })
    }
  }
  @observable groupList = []
  @action
  async onGetGroup(params) {
    this.groupList = []
    try {
      const response = await marketingShortLinkAPI.getGroup(params)
      const {code, data, messageEn} = response?.data

      runInAction(() => {
        if (code === 0) {
          this.groupList = data
        } else {
          alertMessage.error('失败！' + messageEn + '')
        }
      })
      return response?.data
    } catch (err) {
      alertMessage.error('处理异常！'+err.message)
      runInAction(() => {
      })
    }
  }

  @action
  onChangeJob(value) {
    this.jobList = value
    this.itemCount = 0
  }

  /*SearchResult end*/

  /*add*/
  @action
  async onAddJobAction(params, title) {
    this.isFetching = true
    try {
      const response = await marketingShortLinkAPI.addAction(params)
      runInAction(() => {
        this.isFetching = false
        if (response.data?.code === 0) {
          alertMessage.success(title === 'edit' ? '编辑成功！' : '添加成功！')
          this.onSearchJobAction(this.searchItem)
        } else {
          alertMessage.error(title === 'edit' ? '编辑失败！' + response.data?.messageEn : '添加失败！' + response.data?.messageEn)
        }
      })
      return response
    } catch (err) {
      alertMessage.error('处理异常！'+err.message)
      runInAction(() => {
        this.isFetching = false
      })
    }
  }

  /*get edit*/
  @observable detailsObj = null

  @action
  async onGetJobAction(params) {
    this.isFetching = true
    try {
      const response = await marketingShortLinkAPI.getAction(params)
      runInAction(() => {
        this.isFetching = false
        const {data} = response.data
        if (response.data.code === 0) {
          this.detailsObj = data || null
        }
      })
      return response.data.data
    } catch (err) {
      alertMessage.error('处理异常！'+err.message)
      runInAction(() => {
        this.isFetching = false
      })
    }
  }

  /*delete*/
  @action
  async onDeleteJobAction(params) {
    this.isFetching = true
    try {
      const response = await marketingShortLinkAPI.deleteAction(params)
      runInAction(() => {
        this.isFetching = false
        if (response.data.code === 0) {
          alertMessage.success('删除成功！')
          this.onSearchJobAction({
            ...this.searchItem,
            'page': 1,
            'size': PAGE_SIZE_DEFAULT,
          })
        } else {
          alertMessage.error('删除失败！' + response.data.messageEn + '')
        }
      })
    } catch (err) {
      alertMessage.error('处理异常！'+err.message)
      runInAction(() => {
        this.isFetching = false
      })
    }
  }

  @action
  async onSyncAction(){
    this.isFetching = true
    try {
      const response = await marketingShortLinkAPI.syncAction()
      runInAction(() => {
        this.isFetching = false
        if (response.data.code === 0) {
          alertMessage.success('同步成功！')
          this.onSearchJobAction({
            ...this.searchItem,
            'page': 1,
            'size': PAGE_SIZE_DEFAULT,
          })
          this.onRemainingNumberAction()
        } else {
          alertMessage.error('同步失败！' + response.data.messageEn + '')
        }
      })
    } catch (err) {
      alertMessage.error('处理异常！'+err.message)
      runInAction(() => {
        this.isFetching = false
      })
    }
  }

  @observable maxCreateCount = 0
  @action
  async onRemainingNumberAction(){
    this.isFetching = true
    this.maxCreateCount = 0
    try {
      const response = await marketingShortLinkAPI.remainingNumberAction()
      runInAction(() => {
        this.isFetching = false
        if (response.data.code === 0) {
          this.maxCreateCount = response.data.data
        }
      })
    } catch (err) {
      alertMessage.error('处理异常！'+err.message)
      runInAction(() => {
        this.isFetching = false
      })
    }
  }

  @action
  onChangePageNumAction(pageNo, pageSize) {
    if (this.pageNo === pageNo && (!pageSize || this.pageSize === pageSize)) {
      return
    }
    runInAction(() => {
      this.pageNo = pageNo
      this.pageSize = pageSize
    })
    this.onSearchJobAction({
      'groupName': this.searchItem.groupName,
      'configName': this.searchItem.configName,
      'shortLinkType': this.searchItem.shortLinkType,
      'isPowerUser' : this.searchItem.isPowerUser,
      'page': pageNo,
      'size': pageSize,
    })
  }
}
